import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as Actions from '../../Actions';

const CntbkUsersDispatcher = ({originUsers}) => {
  const dispatch = useDispatch();
  useEffect(()=>{
    return () =>{
      setTimeout(()=>{
        const closed = !document.querySelector('#userDispatcher2125');
        if (closed){
          dispatch(Actions.setStore({users: originUsers}));
        }
      }, 100)
    }
  }, [originUsers])
  return (
    <div id='userDispatcher2125' style={{display: 'none'}}></div>
  )
}
export default CntbkUsersDispatcher